<!--
The required combination of attributes is required to handle all of the
different url types that may come from CMS.

Use-Cases to test if you modify this component:
  - `#hasonly`
  - `url/path/and#hash`
  - `url/path`
  - `url/path/with/document.pdf`

Attributes:
  - `click` - Ignores `href` and handles custom click event for url use cases (except file/pdf)
  - `href` - required to support accessibility and right click open options
  - `target` - required if url contains pdf since click event is not triggered
-->

<ng-container *ngIf="isConsentPath">
  <digital-platform-trustarc-cm mode="button"> </digital-platform-trustarc-cm>
</ng-container>

<ng-container *ngIf="!isConsentPath">
  <a
    [href]="localHref"
    [ngClass]="klass"
    [target]="navigationHelperService.isSupportedFile(url) ? '_blank' : target"
    (click)="navigate($event, url)"
    [attr.analytics-alternate-text]="analyticsLinkText"
    rel="noopener"
    [style]="styling"
  >
    <ng-container *ngTemplateOutlet="tempOutlet"></ng-container>
  </a>
</ng-container>

<ng-template #tempOutlet>
  <ng-content></ng-content>
</ng-template>
